<!-- 费用明细信息 -->
<template>
  <div>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      size="mini"
      ref="ruleTable"
      :edit-rules="validRules"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      align="center"
      auto-resize
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import inputNumber from '@/components/form-item/input-number';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import searchTable from '@/components/form-item/search-table';
  // import dictSelect from '@/components/DictSelect';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import API from '@/api/financeCenter/saleInvoice.js';
  import BASE_API from '@/api/dataBase.js';
  // import Lad_API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill';
  // import RETURN_API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  // import SALE_API from '@/api/purchaseSalesCenter/businessOrder.js';
  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
      validateInbound: {
        type: Function,
        default: null,
      },
      dictList: {
        type: Object,
        default: () => {},
      },
      lading: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      // inputNumber,
      // searchTable,
      // ajaxSelect,
      // dictSelect,
      // inputNumberAd,
    },
    data() {
      return {
        tableData: [
          {
            materialAmount: '',
            mcamountWithoutTax: '',
            taxRate: '',
            mcAmountWithTax: '',
            settlementAmount: '',
            settlementPrice: '',
            inboundQuantity: '',
            inboundBatchNo: '',
            contractType: '',
          },
        ],
        invoiceType: '',
        companyCode: '',
        departmentList: [],
        ladingQuantity: '', //原材料数量
        ladingPrice: '', //原材料单位金额
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      validRules() {
        const prefixInput = this.$t('mcInboundEdit.msg.rules.input');
        const prefixSelect = this.$t('mcInboundEdit.msg.rules.select');
        return {
          inboundQuantity: [
            {
              required: true,
              message: prefixInput + this.$t('mcInboundEdit.costInfo.inboundQuantity'),
            },
          ],
          businessContractPrice: [
            {
              required: true,
              message: prefixInput + this.$t('mcInboundEdit.costInfo.businessContractPrice'),
            },
          ],
          taxCode: [
            {
              required: true,
              message: prefixSelect + this.$t('mcInboundEdit.costInfo.taxCode'),
            },
          ],
          productTaxCode: [
            {
              required: true,
              message: prefixSelect + this.$t('mcInboundEdit.costInfo.productTaxRate'),
            },
          ],
          productAmountWithTax: [
            {
              required: true,
              message: prefixInput + this.$t('mcInboundEdit.costInfo.productAmountWithTax'),
            },
          ],
          mcAmountWithTax: [
            {
              required: true,
              message: prefixInput + this.$t('mcInboundEdit.costInfo.mcAmountWithTax'),
            },
          ],
        };
      },

      columnList() {
        return [
          // { type: "checkbox", width: 50 },
          // {title: this.$t('mcInboundEdit.column.sortNo'), field: "sortNo", type: "seq", width: 60},//序号
          //商品描述（产成品描述）
          {
            title: this.$t('mcInboundEdit.costInfo.productDesc'),
            field: 'productDesc',
            width: 120,
          },
          //商品编码（产成品编码）
          { title: this.$t('mcInboundEdit.costInfo.productNo'), field: 'productNo', width: 120 },
          //合同数量
          {
            title: this.$t('mcInboundEdit.costInfo.contractQuantity'),
            field: 'contractQuantity',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumnForNum(row.contractQuantity)}</span>,
                ];
              },
            },
          },
          //产成品入库数量 商品入库数量
          {
            title: this.$t('mcInboundEdit.costInfo.inboundQuantity'),
            field: 'inboundQuantity',
            width: 180,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumnForNum(row.inboundQuantity)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['inboundQuantity']}
                    placeholder={this.$t('mcInboundEdit.costInfo.inboundQuantityPlaceholder')}
                    clearable={true}
                    precision={3}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'inboundQuantity')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //单位
          {
            title: this.$t('mcInboundEdit.costInfo.productUnit'),
            field: 'productUnit',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.dictList.unitOptions,
              props: { clearable: true, filterable: true, disabled: true },
            },
          },
          //加工费单价 合同单价
          {
            title: this.$t('mcInboundEdit.costInfo.businessContractPrice'),
            field: 'businessContractPrice',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.businessContractPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['businessContractPrice']}
                    placeholder={this.$t('mcInboundEdit.costInfo.businessContractPricePlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'businessContractPrice')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //不含税产成品结算价 商品结算价
          {
            title: this.$t('mcInboundEdit.costInfo.settlementPrice'),
            field: 'settlementPrice',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.settlementPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementPrice']}
                    placeholder={this.$t('mcInboundEdit.costInfo.settlementPricePlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'settlementPrice')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //含税产成品总金额
          {
            title: this.$t('mcInboundEdit.costInfo.productAmountWithTax'),
            field: 'productAmountWithTax',
            width: 200,
          },
          //产成品税率
          {
            title: this.$t('mcInboundEdit.costInfo.productTaxRate'),
            field: 'productTaxCode',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.taxRateList,
              props: { clearable: true },
              events: {
                change: (obj) =>
                  this.updateCol(obj.row, obj.row['productTaxCode'], 'productTaxCode'),
              },
            },
          },
          //不含税产成品总金额 商品总金额
          {
            title: this.$t('mcInboundEdit.costInfo.settlementAmount'),
            field: 'settlementAmount',
            width: 200,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.settlementAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementAmount']}
                    placeholder={this.$t('mcInboundEdit.costInfo.settlementAmountPlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'settlementAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //产成品税额
          {
            title: this.$t('mcInboundEdit.costInfo.productTaxAmount'),
            field: 'productTaxAmount',
            width: 120,
          },
          //含税加工费总金额
          {
            title: this.$t('mcInboundEdit.costInfo.mcAmountWithTax'),
            field: 'mcAmountWithTax',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.mcAmountWithTax)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['mcAmountWithTax']}
                    placeholder={this.$t('mcInboundEdit.costInfo.mcAmountWithTaxPlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'mcAmountWithTax')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //加工费税率 税率
          {
            title: this.$t('mcInboundEdit.costInfo.taxRate'),
            field: 'taxCode',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.taxRateList,
              props: { clearable: true },
              events: { change: (obj) => this.updateCol(obj.row, obj.row['taxCode'], 'taxCode') },
            },
          },
          //不含税加工费总金额
          {
            title: this.$t('mcInboundEdit.costInfo.mcAmountWithoutTax'),
            field: 'mcAmountWithoutTax',
            width: 180,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.mcAmountWithoutTax)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['mcAmountWithoutTax']}
                    placeholder={this.$t('mcInboundEdit.costInfo.mcAmountWithoutTaxPlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'mcAmountWithoutTax')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          //加工费税额
          {
            title: this.$t('mcInboundEdit.costInfo.mcTaxWithout'),
            field: 'mcTaxWithout',
            width: 120,
          },
          //不含税原材料总金额=原材料金额的合集
          {
            title: this.$t('mcInboundEdit.costInfo.materialAmount'),
            field: 'materialAmount',
            width: 180,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.materialAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['materialAmount']}
                    placeholder={this.$t('mcInboundEdit.costInfo.materialAmountPlaceholder')}
                    clearable={true}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'materialAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'matchedQuantity',
            title: '已匹配数量',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumnForNum(row.matchedQuantity)}</span>,
                ];
              },
            },
          }, //已匹配数量
          {
            field: 'matchAvailableQuantity',
            title: '可匹配数量',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumnForNum(row.matchAvailableQuantity)}
                  </span>,
                ];
              },
            },
          }, //可匹配数量
          // {title: this.$t('mcInboundEdit.costInfo.distributionInboundNo'), field: "distributionInboundNo", width: 120 },//商品物流入库单号
          //委托加工采购合同号
          { title: this.$t('mcInboundEdit.costInfo.contractNo'), field: 'contractNo', width: 120 },
          //委托加工采购合同行号
          {
            title: this.$t('mcInboundEdit.costInfo.contractDetailNo'),
            field: 'contractDetailNo',
            width: 120,
          },
          //委托加工外部合同号
          {
            title: this.$t('mcInboundEdit.costInfo.externalContractNo'),
            field: 'externalContractNo',
            width: 120,
          },
          //产成品业务入库批次号
          {
            title: this.$t('mcInboundEdit.costInfo.inboundBatchNo'),
            field: 'inboundBatchNo',
            width: 120,
          },
          // {title: this.$t('mcInboundEdit.costInfo.instructionNo'), field: "instructionNo", width: 120 },//供应商发货指令号
          // {title: this.$t('mcInboundEdit.costInfo.instructionDetailNo'), field: "instructionDetailNo", width: 120 },//供应商发货指令行号
          // {title: this.$t('mcInboundEdit.costInfo.contractType'), field: "contractType", width: 120,
          //  editRender: {
          //     name: "ElSelect",
          //     options: this.dictList.contractType,
          //     props: {clearable:true,filterable: true,disabled: true}
          //   }
          // },//合同类型
          // {title: "批次号", field: "inboundBatchNo", width: 180},//批次号
        ];
      },
      taxRateList() {
        // return this.$baseRequest.getDictListMapByType("tax_rate") || []
        console.log(this.dictList.taxRateList);
        return this.dictList.taxRateList;
      },
    },
    mounted() {},
    watch: {},
    methods: {
      handleInsert() {
        // this.validateInbound().then(()=>{
        //   const userInfo = this.userInfo;
        //   let params = {
        //       reversePaymentLinesId: this.invoiceInfo.reversePaymentLinesId || 0,
        //       currency: this.invoiceInfo.currency
        //   }
        //   params = this.$baseRequest.assignObj(params)
        //   this.$refs.ruleTable
        //     .insertAt(params, -1)
        //     .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
        // }).catch(()=>{
        //     console.log("handleInsertErr")
        // })
        // 如果公司、汇率、币种不存在提示
        /*  if (!validateInboundRes) {
        this.$message({
          showClose: true,
          message: '请完善发票信息',
          type: "error"
        });
        return;
      } */
      },
      //抛出表格数据
      exportTableData() {
        let inboundDetail = this.$refs.ruleTable.getTableData().fullData;
        console.log(inboundDetail);
        return inboundDetail;
      },
      // 取一级部门的最后一级部门
      async getLastDepart(v) {
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: v,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
          console.log(this.departmentList);
        }
      },
      activeRowMethod() {
        //禁用编辑
        console.log(this.canEdit);
        return this.canEdit;
      },
      // editRender更新字段
      // updateEvent(obj,type){
      //   console.log(obj)
      //   let row = obj.row;
      //   row['taxRate'] = this.taxRateList.find(it=>it.taxCode==row.taxCode).taxRate
      //   row['productTaxRate'] = this.taxRateList.find(it=>it.taxCode==row.taxCode).taxRate
      //   console.log(row)
      // },
      //JSX更新字段
      updateCol(row, val, type) {
        console.log(row);
        console.log(type);
        row[type] = val;
        if (type == 'taxCode') {
          row['taxRate'] = val
            ? this.taxRateList.find((it) => it.value == row['taxCode']).taxRate
            : '';
        }
        if (type == 'productTaxCode') {
          row['productTaxRate'] = '';
          if (val) {
            row['productTaxRate'] = this.taxRateList.find(
              (it) => it.value == row['productTaxCode']
            ).taxRate;
          }
        }

        // 不含税商品结算价=不含税商品总金额/商品入库数量
        row['settlementPrice'] = this.$cal.calCommon(
          row['settlementAmount'] || 0,
          row['inboundQuantity'],
          '/',
          'amount'
        );
        // 含税加工费总金额=商品入库数量*加工费单价 --原逻辑ID1002005 输入单价
        // row['mcAmountWithTax'] = this.$cal.calCommon(row['inboundQuantity']||0, row['businessContractPrice'],"*",'amount')
        // 含税加工费总金额（手填）/产成品入库数量（手填）= 加工费单价（自动计算）  --现逻辑ID1002005 输入加工费总额
        row['businessContractPrice'] = this.$cal.calCommon(
          row['mcAmountWithTax'],
          row['inboundQuantity'],
          '/',
          'price'
        );
        console.log(row['taxRate']);
        // 加工费税额=含税加工费/(1+税率）*税率
        let step1 = this.$cal.calCommon(1, row['taxRate'], '+', '');
        let step2 = this.$cal.calCommon(row['mcAmountWithTax'], step1, '/', '');
        row['mcTaxWithout'] = this.$cal.calCommon(step2, row['taxRate'], '*', 'amount');
        // 不含税加工费 = 含税加工费-加工费税额
        row['mcAmountWithoutTax'] = this.$cal.calCommon(
          row['mcAmountWithTax'] || 0,
          row['mcTaxWithout'],
          '-',
          'amount'
        );
        console.log(row['mcAmountWithoutTax']);
        // 不含税产成品总金额=不含税加工费+不含税原材料总金额
        row['settlementAmount'] = this.$cal.calCommon(
          row['mcAmountWithoutTax'] || 0,
          row['materialAmount'] || 0,
          '+',
          'amount'
        );
        // 不含税商品结算价=不含税产成品总金额/商品入库数量
        row['settlementPrice'] = this.$cal.calCommon(
          row['settlementAmount'] || 0,
          row['inboundQuantity'],
          '/',
          'price'
        );
        // 含税产成品总金额 = 不含税产成品总金额*(1+产成品税率）
        let step11 = this.$cal.calCommon(1, row['productTaxRate'], '+', ''); //(1+产成品税率）
        row['productAmountWithTax'] = this.$cal.calCommon(
          row['settlementAmount'] || 0,
          step11,
          '*',
          'amount'
        );
        // 产成品税额 = 含税产成品总金额-不含税产成品总金额
        row['productTaxAmount'] = this.$cal.calCommon(
          row['productAmountWithTax'],
          row['settlementAmount'],
          '-',
          'amount'
        );
      },

      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.tableData;
        return tableData.map((item, index) => {
          const result = Object.assign({}, item, {
            invoiceDetailCode: item.invoiceDetailCode || index + 1,
          });
          return result;
        });
      },

      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columnsList.forEach((item) => {
          const required = typeof item.required === 'function' ? item.required() : item.required;
          if (required) {
            const title = this.$t('saleInvoice.' + (item.otherKey || item.field));
            const message = title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });
        return rules;
      },
      // 币种格式转换
      fotmatCurrency({ cellValue }) {
        console.log(cellValue);
        if (cellValue)
          return this.currencyList.find((it) => it.currencyCode == cellValue).currencyName;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
